<template>
  <div>
    <arrorImg bg="white"></arrorImg>
    <navBar title="消费记录" color="#ffffff"></navBar>
    <div class="content-box">
      <div class="content" v-if="!isEmpaty">
        <ul
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <li
            class="consume-item"
            v-for="(item, index) in customList"
            :key="index"
          >
            <div class="consum-left">
              <span>{{
                item.isLuckPurchase == 0
                  ? "抽奖活动"
                  : "订阅《" + item.bookName + "》"
              }}</span>
              <span
                ><span style="color: #de3b34">-{{ item.spendCurrency }}</span
                >书币</span
              >
            </div>
            <div class="consum-right">
              <span v-if="item.isLuckPurchase == 0"> </span>
              <span v-else>{{
                item.purchaseType == 1
                  ? "整本 "
                  : "第" + item.chapterNum + "章 " + item.chapterName
              }}</span>
              <span>{{ item.purchaseTime }}</span>
            </div>
          </li>
        </ul>
        <div class="load-more">
          <span>{{ !isLoading ? "加载中" : loadText }}</span>
        </div>
      </div>
      <div class="no-log" v-else>
        <img src="../../../static/no-log.png" alt="" />
        <span>暂无记录~</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox, InfiniteScroll } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      loading: false,
      isEmpaty: false,
      pageNo: 1,
      customList: [],
      loadText: "加载中...",
      pageCount: 1,
      isEntranceData: "",
      isLoading: false,
      pageType:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    this.pageType = this.$route.query.pageType;
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
     var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized == 0 &&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.paylog();
    } else {
      this.paylog();
    }
    this.$commonApi.share();
  },
  methods: {
    loadMore() {
      this.loading = true;
      if (this.pageNo < this.pageCount) {
        this.pageNo += 1;
        this.paylog();
      } else {
        this.loadText = "没有更多了";
        this.loading = false;
      }
    },

    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCity") {
        prevPage = "书城";
      } else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      } else if (this.pageType === "bookMine") {
        prevPage = "我的";
      }
      var params = {
        pageName: "消费记录",
        pageRemark: "上级页面："+prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    paylog() {
      var params = {
        pageNo: this.pageNo,
        pageSize: 10,
      };
      this.isLoading = false;
      this.$api.paylog(params).then((res) => {
        if (res.status == 1) {
          this.pageCount = res.pages;
          if (this.pageNo == 1) {
            this.customList = res.data;
            if (this.pageCount <= 1) {
              this.loadText = "没有更多了";
            } else {
              this.loadText = "加载中...";
            }
          } else {
            this.customList = this.customList.concat(res.data);
          }
          if (this.customList.length == 0) {
            this.isEmpaty = true;
          } else {
            this.isEmpaty = false;
          }
          this.isLoading = true;
          this.insertPageAccessData();
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  padding: 0px 16px;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
  border-top: 1px solid #f3f3f3;
}

.consume-item {
  width: 100%;
  padding: 12px 0px;
  border-bottom: 1px solid #f3f3f3;
}

.content-box {
  padding-top: calc(44px + env(safe-area-inset-top));
}
.consum-left {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.consum-left > span {
  display: block;
  font-size: 14px;
  color: #3d3d3d;
}
.consum-left > span:nth-child(1) {
  margin-bottom: 4px;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
  height: 20px;
}
.consum-right {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}
.consum-right > span:nth-child(1) {
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 60%;
}
.consum-right > span:nth-child(2) {
  color: #aaaaaa;
  text-align: right;
}
.load-more {
  text-align: center;
  font-size: 12px;
  color: #aaaaaa;
  padding: 16px 0px;
}

.no-log {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.no-log img {
  width: 128px;
  height: 128px;
  display: block;
  margin: 0 auto;
}

.no-log span {
  display: block;
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookConsume/index.vue